export default Object.freeze({
    PRACTICE: 'practice',
    NETWORK: 'network',
})
